module.exports = __webpack_public_path__ + "static/media/photo137.44d19449.jpg";